/** Precio mensual publicado en listado Spacest (desde búsqueda o ficha). */
export function resolveSpacestListingMonthlyPriceEur(coliving) {
  if (!coliving) return null;
  const n = Number(
    coliving.priceFrom ?? coliving.propertyPrice ?? coliving.price ?? 0,
  );
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.round(n);
}
